import type { PageExperience } from '@/features/experiences/types';
import {
  isDayColumnsLayout,
  type DayColumnsBy,
} from '@/features/layouts/collection/DayByCategory/dayColumns.lib';
import { BlockLayouts, BlockTypes } from '@/types/gql.generated';
import { SidebarRowSelect } from '../SidebarRowSelect';
import { useCustomizeControl } from '../useCustomizeControl';

const LABELS: Record<DayColumnsBy, string> = {
  [BlockLayouts.DayByCategory]: 'Color',
  [BlockLayouts.DayByWho]: 'Who',
  [BlockLayouts.DayByLabel]: 'Label',
  [BlockLayouts.DayBySource]: 'Source',
};

type Props = {
  experience: PageExperience;
  onSetBlockLayout: (blockId: string, layout: BlockLayouts) => void;
};

export const DayColumnsBySelect = ({ experience, onSetBlockLayout }: Props) => {
  const { register } = useCustomizeControl();

  const collectionBlock = experience.blocks.find(
    (block) => block.type === BlockTypes.Collection
  );
  const options = (
    experience.layout.blocks.find((item) => item.type === BlockTypes.Collection)
      ?.layouts ?? []
  )
    .filter(isDayColumnsLayout)
    .map((id) => ({ id, label: LABELS[id] }));

  return (
    <SidebarRowSelect
      minW="120px"
      options={options}
      {...register<'blocks', string>('child', 'blocks', {
        toControl: (blocks) =>
          blocks.find((block) => block.type === BlockTypes.Collection)
            ?.layoutId ??
          options[0]?.id ??
          '',
        toField: (id) =>
          experience.blocks.map((block) =>
            block.id === collectionBlock?.id
              ? { ...block, layoutId: id as BlockLayouts }
              : block
          ),
        commit: (id) => {
          if (collectionBlock) {
            onSetBlockLayout(collectionBlock.id, id as BlockLayouts);
          }
        },
      })}
    />
  );
};
